import React, { useState } from "react";
import { Input, RoundButton } from "../atoms/form/form";
import Layout from "../atoms/layout/layout";
import useApi from "../hooks/use-api";
export default function UpdatePassword() {
  let { exec, status } = useApi({
    endpoint: "updatepassword",
    repeat: true,
  });
  let [newPasswordA, setNewPasswordA] = useState("");
  let [newPasswordB, setNewPasswordB] = useState("");
  let [currentPassword, setCurrentPassword] = useState("");
  return (
    <Layout>
      <div className="siteHeader">Passwort ändern</div>
      <Input
        type={"password"}
        value={currentPassword}
        onChange={(s) => setCurrentPassword(s)}
        label="Altes Password"
      ></Input>
      <Input
        type={"password"}
        value={newPasswordA}
        onChange={(s) => setNewPasswordA(s)}
        label="Neues Passwort"
      ></Input>
      <Input
        type={"password"}
        value={newPasswordB}
        onChange={(s) => setNewPasswordB(s)}
        label="Neues Passwort wiederholen"
      ></Input>
      <RoundButton
        status={status}
        onClick={() =>
          exec({
            currentPassword,
            newPasswordA,
            newPasswordB,
          })
        }
      >
        Neues Passwort speichern
      </RoundButton>
    </Layout>
  );
}
